import React, { useContext } from 'react';
import Icon from '@xo-union/tk-component-icons';

import { Wws_PageItemGuidance } from '../../generated/graphql';
import { Img, Picture } from '@xo-union/tk-component-picture';
import styles from './guidanceItemCard.scss';
import GuidancePreviewImage from './GuidancePreviewImage';
import { Link } from 'react-router-dom';
import { kebabCase } from 'lodash';
import pluralize from 'pluralize';
import { TrackingContext } from '../../TrackingContext';
import { dashboardRoute, previewRoute } from '../../helpers/routes';

interface Props {
  pageId: number;
  guidance?: Wws_PageItemGuidance | null;
  preview?: boolean;
}

const GuidanceItemCard: React.FC<Props> = ({ guidance, pageId, preview }) => {
  const { track } = useContext(TrackingContext);

  if (!guidance) {
    return null;
  }

  const onClick = () => {
    track('Item Action Initiated', { source: 'guidance', type: guidance.type, page: pageId });
  };

  return (
    <div className={styles.guidanceItem} data-testid={`guidance-item-${guidance.type}`}>
      <GuidancePreviewImage>
        <Picture id={guidance.image?.mediaApiId} lazy>
          <Img />
        </Picture>
      </GuidancePreviewImage>
      <div className={styles.guidanceLink}>
        <Link
          to={`${preview ? previewRoute : dashboardRoute}/pages/${pageId}/${pluralize(
            kebabCase(guidance?.type || '')
          )}`}
          onClick={onClick}
        >
          {guidance.ctaText}
          <Icon name="forward" />
        </Link>
      </div>
    </div>
  );
};
export default GuidanceItemCard;
